// eslint-disable-next-line no-shadow
export enum SectionParamOptionsEnum {
  progressChart = 'progressChart',
  taskProgress = 'taskProgress',
  grantees = 'grantees',
}

export type SectionTab = {
  label: string
  param: SectionParamOptionsEnum
  count?: number
}

export type GoalGroupFields = {
  title: string
  description: string | null
  category: string
  startDate: string | null
  endDate: string | null
  target: string | null
  targetDescription: string | null
  isFunderAssigned: boolean
}
